import React from 'react';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { searchActions, searchStatus, cuzkSearchType } from '../../../store/searchStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { MomentDate } from '../../common/momentComponent';
import { Circles } from '../../common/loadingComponent';
import { getParams } from '../../common/utils';
import { writeErr } from '../../common/logger';
import NoDataComponent from '../../common/noDataComponent';
import Message from '../../common/message';

import './propertyCz.scss';

const searchParams = {
    companyId: "companyId",
    pin: "pin",
    name: "name",
    surname: "surname",
    birthDate: "birthDate",
    dataDate: "dataDate"
};

class PropertyCzSearchResults extends React.Component {
    mounted = false;

    state = {
        page: 0,
        items: []
    };

    componentDidMount() {
        this.mounted = true;
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = getParams(window.location.search)
            this.props.cuzkGetRequest({ id: this.props.match.params.id, ...params },
                () => this.updatePage(1),
                (p) => this.props.history.push(`/search/property-cz/report${p}`));
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.mounted)
            return;

        // Restore search results after redirecting back from another page
        const data = this.getSearchResult("data");
        if (this.state.items.length === 0 && !isNullOrUndefined(data) && data.persons.length > 0)
            this.updatePage(1);

        const oldPage = isNullOrUndefined(prevProps.search[cuzkSearchType.subjects]) ? 0 : prevProps.search[cuzkSearchType.subjects].page;
        if (oldPage !== this.getSearchResult("page"))
            this.updatePage(this.getSearchResult("page"));
    }

    render() {
        if (this.getSearchResult("status") === searchStatus.requested)
            return <Circles />;

        const error = this.getSearchResult("error"); 

        if (!isNullOrUndefined(error)) {
            return (
                <div className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                    <Message type={error.exceptionLevel || "error"} options={{ renderInnerHtml: true }} message={this.props.translate(error.exception || "UnhappyUser.InternalServerError", isNullOrUndefined(error.exceptionData) ? undefined : error.exceptionData)} />
                </div>
            );
        }

        const data = this.getSearchResult("data");

        if (!isNullOrUndefined(data) && !isNullOrUndefined(data.exception)) {
            const msg = !isNullOrUndefined(data.exceptionData) ? this.props.translate(data.exception, data.exceptionData) : this.props.translate(data.exception);
            return (
                <div className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                    <Message type={data.exceptionLevel || "error"} message={msg} options={{ renderInnerHtml: true }} />
                </div>
            );
        }

        if (isNullOrUndefined(data))
            return <NoDataComponent />;

        const params = data;
        var searchParams = [];
        if (params.name)
            searchParams.push(<><Translate id='PropertyCz.Search.Name' />: <b>{params.name}</b></>);
        if (params.surname)
            searchParams.push(<><Translate id='PropertyCz.Search.Surname' />: <b>{params.surname}</b></>);
        if (params.fullName) {
            const arr = params.fullName.split(" ");
            if (arr.length > 0 && arr[0])
                searchParams.push(<><Translate id='PropertyCz.Search.Name' />: <b>{arr[0]}</b></>);
            if (arr.length > 1 && arr[1])
                searchParams.push(<><Translate id='PropertyCz.Search.Surname' />: <b>{arr[1]}</b></>);
        }
        if (params.birthDate)
            searchParams.push(<><Translate id='PropertyCz.Search.BirthDate' />: <b><MomentDate value={params.birthDate} /></b></>);
        if (params.pin)
            searchParams.push(<><Translate id='PropertyCz.Search.Pin' />: <b>{params.pin}</b></>);
        if (params.companyId)
            searchParams.push(<><Translate id='PropertyCz.Search.CompanyId' />: <b>{params.companyId}</b></>);
        if (params.dataDate)
            searchParams.push(<><Translate id='PropertyCz.Search.DataDate' />: <b><MomentDate value={params.dataDate} /></b></>);

        return (
            <>
                {this.renderReportDateInformation(data.insertedFormated, data.completedFormated)}
                <div className='card'>
                    <div style={{ backgroundColor: '#fbfbfb', borderRadius: '10px 10px 0px 0px' }}>
                        <div style={{ padding: '10px 15px' }}>
                            <div><b><Translate id='Search.Parameters' /></b></div>
                            <div style={{ fontSize: '0.8em' }}>
                                {searchParams.map((s, i) => { return i + 1 === searchParams.length ? s : <>{s} | </> })}
                            </div>
                        </div>
                    </div>
                    <div className='card-body'>
                        {this.state.items.map((item, idx) => this.renderItem(item, this.itemIndex(idx), idx === this.state.items.length - 1))}
                        {this.state.items.length === 0 && <div><Translate id='Search.Cee.ResultCount' />: 0</div>}
                    </div>
                </div>
                <div className="disclaimer-wrapper">
                    <div className="report-component" style={{ textAlign: "center" }}><Translate id="Report.Footer" /></div>
                    <hr style={{ marginTop: "4px", marginBottom: "4px", height: "1px" }} />
                    <div className="disclaimer-gray"><Translate id="PropertyCz.Disclaimer" /></div>
                </div>
            </>
        );
    }

    renderReportDateInformation(insertedFormated, completedFormated) {
        return (
            <div className="cuzk-query-date">
                <div>
                    <span><Translate id="PropertyCz.Inserted" />:&nbsp;</span>
                    <span className="bold">{insertedFormated}</span>
                </div>
                <div>
                    <span><Translate id="PropertyCz.Completed" />:&nbsp;</span>
                    <span className="bold">{completedFormated}</span>
                </div>
            </div>
        );
    }

    renderItem = (item, idx, isLast) => {
        return (
            <div key={idx} className={`cuzk-search-result${(isLast ? " last" : "")}`}>
                <div className="cuzk-index">{idx}.</div>
                <div className="cuzk-data">
                    <div className="cuzk-identification">
                        <span className="cuzk-name">
                            <span onClick={() => this.reportLinkClicked(this.getReportLink(item))}>{item.fullName}</span>
                        </span> | {this.renderItemIdentification(item)}
                    </div>
                    <span>{item.address}</span>
                </div>
            </div>
        )
    }

    renderItemIdentification = (item) => {
        if (!isNullOrUndefined(item.birthDate)) {
            return (
                <span>
                    {item.birthDateFormated}
                    {!isNullOrUndefined(item.birthDatePartner) && <>,&nbsp;{item.birthDatePartnerFormated}</>}
                </span>
            );
        }

        if (!isNullOrUndefined(this.getSearchResult("data").companyId)) {
            return <span>{this.getSearchResult("data").companyId}</span>;
        }

        return null;
    }

    getSearchResult = (field) => {
        return (isNullOrUndefined(this.props.search) || isNullOrUndefined(this.props.search[cuzkSearchType.subjects]))
            ? null : this.props.search[cuzkSearchType.subjects][field];
    }

    updatePage = (page) => {
        const data = this.getSearchResult("data");
        if (isNullOrUndefined(data)) {
            writeErr('No subjects in search result');
            return;
        }

        const pageSize = this.getSearchResult("pageSize");
        const maxIndex = data.persons.length;
        const start = (page - 1) * pageSize;
        const end = start + pageSize > maxIndex ? maxIndex : start + pageSize;
        this.setState({ page: page, items: data.persons.slice(start, end) });
    }

    itemIndex = (idx) => (this.getSearchResult("page") - 1) * this.getSearchResult("pageSize") + idx + 1

    getReportLink = (item) => {
        const params = this.getSearchResult("data");
        let link = `report?osId=${item.id}`;

        if (!isNullOrUndefined(params.dataDate))
            link += "&dataDate=" + params.dataDate;
        if (item.matchType === 1 || item.matchType === 2) {
            if (isNullOrUndefined(params.companyId)) {
                if (!isNullOrUndefined(params.pin) && params.pin !== "")
                    link += "&pin=" + params.pin;
            }
            else
                link += "&companyId=" + params.companyId;
        }
        if (item.matchType === 2 && isNullOrUndefined(params.companyId))
            link += "&fnm=" + item.fullName

        return link;
    }

    reportLinkClicked = (url) => {
        this.props.cuzkReset(cuzkSearchType.report);
        this.props.history.push(`/search/property-cz/${url}`);
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search.cuzk }, layout: state.layout }),
    dispatch => bindActionCreators(searchActions, dispatch)
)(PropertyCzSearchResults)));
